import React, { useState } from 'react';

// --- QUESTION HELPER COMPONENT ---
const Question = ({ qNo, eng, urdu, name, answers, handleAnswerChange }) => (
  <div style={{ marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
    <div style={{ fontSize: '15px', fontWeight: '600', color: '#1f2937', marginBottom: '5px' }}>{qNo}) {eng}</div>
    <div style={{ fontSize: '16px', color: '#4b5563', marginBottom: '10px', textAlign: 'right', direction: 'rtl' }}>{urdu}</div>
    <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '15px', fontWeight: '500' }}>
        <input type="radio" name={name} checked={answers[name] === 'Yes'} onChange={() => handleAnswerChange(name, 'Yes')} /> 
        Yes / ہاں
      </label>
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '15px', fontWeight: '500' }}>
        <input type="radio" name={name} checked={answers[name] === 'No'} onChange={() => handleAnswerChange(name, 'No')} /> 
        No / نہیں
      </label>
    </div>
  </div>
);

// --- MAIN COMPONENT ---
const Part2Form = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [candidateInfo, setCandidateInfo] = useState({
    name: '', position: '', date: new Date().toISOString().split('T')[0]
  });

  const [answers, setAnswers] = useState({
    q1: '', q2: '', q2_details: '', q3: '', q3_details: '', q4: '',
    q5: '', q6: '', q7: '', q8: '',
    q9: '', q9_details: '', q10: '', q11: '', q12: '', q13: '', q14: '', q14_details: '', q15: '', q16: '',
    shoe_size: '', waist_size: '',
    q17: '',
    contact1_name: '', contact1_relation: '', contact1_phone: '',
    contact2_name: '', contact2_relation: '', contact2_phone: '',
    q18: '', q19: '', q19_details: '', q20: '', q21: ''
  });

  const handleInfoChange = (e) => setCandidateInfo({ ...candidateInfo, [e.target.name]: e.target.value });
  const handleAnswerChange = (key, val) => setAnswers({ ...answers, [key]: val });
  const handleTextChange = (e) => setAnswers({ ...answers, [e.target.name]: e.target.value });

  const validateForm = () => {
    if (!candidateInfo.name.trim() || !candidateInfo.position.trim() || !candidateInfo.date) {
      alert("Please fill in all Candidate Information fields (Name, Position, Date).");
      return false;
    }
    if (answers.q2 === 'Yes' && !answers.q2_details.trim()) { alert("Please provide details for Question 2."); return false; }
    if (answers.q3 === 'Yes' && !answers.q3_details.trim()) { alert("Please provide details for Question 3."); return false; }
    if (answers.q9 === 'Yes' && !answers.q9_details.trim()) { alert("Please provide details for Question 9."); return false; }
    if (answers.q14 === 'Yes' && !answers.q14_details.trim()) { alert("Please provide details for Question 14."); return false; }
    if (answers.q19 === 'Yes' && !answers.q19_details.trim()) { alert("Please provide details for Question 19."); return false; }

    const requiredQuestions = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10', 
                               'q11', 'q12', 'q13', 'q14', 'q15', 'q16', 'q17', 'q19', 'q20'];
    for (let q of requiredQuestions) {
      if (!answers[q]) { alert(`Please answer Question ${q.replace('q', '')}`); return false; }
    }

    if (!answers.q18.trim()) { alert("Please answer Question 18."); return false; }
    if (!answers.q21.trim()) { alert("Please provide your Blood Group (Q21)."); return false; }
    if (!answers.shoe_size.trim()) { alert("Please provide your Shoe Size."); return false; }
    if (!answers.waist_size.trim()) { alert("Please provide your Waist Size."); return false; }

    if (!answers.contact1_name.trim() || !answers.contact1_relation.trim() || !answers.contact1_phone.trim()) {
      alert("Please complete Emergency Contact 1 information."); return false;
    }
    if (!answers.contact2_name.trim() || !answers.contact2_relation.trim() || !answers.contact2_phone.trim()) {
      alert("Please complete Emergency Contact 2 information."); return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);
    const formData = { ...candidateInfo, ...answers, submittedAt: new Date().toISOString() };
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbxJUuqoZwrAZqleKtM7r5nQMmKuaJ9qYO_99-TMq0CIracjp3ah5N8YSzlEfUXm1qtt/exec', {
        method: 'POST',
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      if (result.success) {
        alert('Form Submitted Successfully! | فارم کامیابی سے جمع کرایا گیا');
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit form. Please check your internet connection.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const styles = {
    wrapper: { backgroundColor: '#f3f4f6', maxHeight: '100vh', overflowY: 'auto', padding: '20px', fontFamily: "'Inter', sans-serif" },
    container: { maxWidth: '850px', margin: '0 auto', backgroundColor: '#ffffff', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', borderRadius: '12px', overflow: 'hidden' },
    header: { display: 'flex', alignItems: 'center', gap: '20px', backgroundColor: '#ffffff', color: 'Black', padding: '25px', borderBottom: '5px solid #1e3a8a' },
    logo: { height: '70px', backgroundColor: 'white', padding: '5px', borderRadius: '8px', objectFit: 'contain' },
    urduTitle: { fontSize: '18px', fontWeight: '500', marginTop: '5px' },
    body: { padding: '30px' },
    infoGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px', backgroundColor: '#f8fafc', padding: '20px', borderRadius: '8px', border: '1px solid #e2e8f0' },
    inputGroup: { display: 'flex', flexDirection: 'column' },
    label: { fontSize: '13px', fontWeight: '600', color: '#4b5563', marginBottom: '6px', display: 'flex', justifyContent: 'space-between' },
    urduLabel: { fontWeight: 'normal', color: '#6b7280', fontSize: '14px' },
    input: { padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', transition: 'border 0.2s', width: '100%', boxSizing: 'border-box' },
    section: { marginBottom: '35px' },
    sectionHeader: { fontSize: '18px', fontWeight: 'bold', color: '#1e3a8a', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between' },
    contactsGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '15px' },
    contactBox: { border: '1px solid #d1d5db', padding: '15px', borderRadius: '8px', backgroundColor: '#fafafa' },
    contactTitle: { fontWeight: 'bold', color: '#111827', marginBottom: '10px', borderBottom: '1px solid #e5e7eb', paddingBottom: '5px' },
    declaration: { backgroundColor: '#ecfdf5', padding: '20px', borderRadius: '8px', border: '1px solid #10b981', marginTop: '30px' },
    decText: { fontSize: '14px', color: '#047857', marginBottom: '10px', lineHeight: '1.5' },
    signaturesRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '25px', marginTop: '20px' }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        
        {/* --- HEADER --- */}
        <div style={styles.header}>
          <img src="sowash.jpeg" alt="Sowash Logo" style={styles.logo} />
          <div>
            <div style={styles.urduTitle}>EMPLOYEE HIRING QUESTIONNAIRE | ہاں / نہیں سوالنامہ</div>
          </div>
        </div>

        <div style={styles.body}>
          {/* --- CANDIDATE INFO --- */}
          <div style={styles.infoGrid}>
            <div style={styles.inputGroup}>
              <label style={styles.label}><span>Candidate Name:</span> <span style={styles.urduLabel}>امیدوار کا نام</span></label>
              <input style={styles.input} name="name" value={candidateInfo.name} onChange={handleInfoChange} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}><span>Position Applied For:</span> <span style={styles.urduLabel}>مطلوبہ عہدہ</span></label>
              <input style={styles.input} name="position" value={candidateInfo.position} onChange={handleInfoChange} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}><span>Date:</span> <span style={styles.urduLabel}>تاریخ</span></label>
              <input type="date" style={styles.input} name="date" value={candidateInfo.date} onChange={handleInfoChange} />
            </div>
          </div>

          {/* --- SECTION 1: EMPLOYMENT & DISCIPLINE --- */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <span>Employment & Discipline</span>
              <span style={{fontFamily: "'Noto Nastaliq Urdu', serif"}}>ملازمت اور نظم و ضبط</span>
            </div>
            <Question qNo="1" name="q1" eng="Have you ever been terminated or resigned due to disciplinary issues?" urdu="کیا آپ کو کبھی نظم و ضبط کے مسئلے کی وجہ سے نوکری سے نکالا گیا یا استعفیٰ دینا پڑا؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="2" name="q2" eng="Have you ever had a conflict or serious complaint with any customer in the past?" urdu="کیا ماضی میں آپ کا کسی کسٹمر کے ساتھ کوئی تنازعہ یا سنجیدہ شکایت رہی ہے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            {answers.q2 === 'Yes' && (
              <div style={{marginTop: '-10px', marginBottom: '20px'}}>
                <label style={styles.label}><span>If yes, briefly explain how you resolved it:</span> <span style={styles.urduLabel}>اگر ہاں مختصراً بتائیں کہ آپ نے مسئلہ کس طرح حل کیا</span></label>
                <input style={styles.input} name="q2_details" value={answers.q2_details} onChange={handleTextChange} />
              </div>
            )}
            <Question qNo="3" name="q3" eng="Have you ever faced any problem or conflict with your co-workers or team members?" urdu="کیا آپ کو کبھی اپنے ساتھی ملازمین یا ٹیم ممبرز کے ساتھ کسی مسئلے یا تنازعے کا سامنا کرنا پڑا؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            {answers.q3 === 'Yes' && (
              <div style={{marginTop: '-10px', marginBottom: '20px'}}>
                <label style={styles.label}><span>If yes, briefly explain how you resolved it:</span> <span style={styles.urduLabel}>اگر ہاں، مختصراً بتائیں کہ آپ نے اس مسئلے کو کیسے حل کیا</span></label>
                <input style={styles.input} name="q3_details" value={answers.q3_details} onChange={handleTextChange} />
              </div>
            )}
            <Question qNo="4" name="q4" eng="Have you had any serious conflict or fight with your previous manager or supervisor?" urdu="کیا آپ کا اپنے پچھلے منیجر یا سپروائزر کے ساتھ کوئی سنجیدہ تنازعہ یا جھگڑا ہوا تھا؟" answers={answers} handleAnswerChange={handleAnswerChange} />
          </div>

          {/* --- SECTION 2: WORK COMMITMENT --- */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <span>Work Commitment</span>
              <span style={{fontFamily: "'Noto Nastaliq Urdu', serif"}}>کام سے وابستگی</span>
            </div>
            <Question qNo="5" name="q5" eng="Can you work six (6) days a week as per company requirement?" urdu="کیا آپ کمپنی کی ضرورت کے مطابق ہفتے میں چھ (6) دن کام کر سکتے ہیں؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="6" name="q6" eng="Can you work extra hours during the day if required?" urdu="کیا ضرورت پڑنے پر آپ اضافی اوقات میں کام کر سکتے ہیں؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="7" name="q7" eng="If you get a new job elsewhere, will you provide a minimum 30-day written notice before leaving?" urdu="اگر آپ کو کہیں اور نوکری مل جائے، تو کیا آپ کمپنی چھوڑنے سے پہلے کم از کم 30 دن کا تحریری نوٹس دیں گے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="8" name="q8" eng="Do you agree that in case you leave without notice, the company may withhold your salary?" urdu="کیا آپ متفق ہیں کہ نوٹس پیریڈ کے بغیر نوکری چھوڑنے پر کمپنی تنخواہ روک سکتی ہے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
          </div>

          {/* --- SECTION 3: PERSONAL & GENERAL INFO --- */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <span>Personal & General Information</span>
              <span style={{fontFamily: "'Noto Nastaliq Urdu', serif"}}>ذاتی اور عمومی معلومات</span>
            </div>
            <Question qNo="9" name="q9" eng="Any blood relative currently working in the company?" urdu="کیا کمپنی میں آپ کا کوئی قریبی رشتہ دار کام کر رہا ہے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            {answers.q9 === 'Yes' && (
              <div style={{marginTop: '-10px', marginBottom: '20px'}}>
                <label style={styles.label}><span>If yes, name & relation:</span> <span style={styles.urduLabel}>اگر ہاں نام اور رشتہ</span></label>
                <input style={styles.input} name="q9_details" value={answers.q9_details} onChange={handleTextChange} />
              </div>
            )}
            <Question qNo="10" name="q10" eng="Do you own a smartphone?" urdu="کیا آپ کے پاس ذاتی اسمارٹ فون ہے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="11" name="q11" eng="Do you own a motorcycle?" urdu="کیا آپ کے پاس موٹر سائیکل ہے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="12" name="q12" eng="Do you own a car?" urdu="کیا آپ کے پاس کار ہے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="13" name="q13" eng="Can you climb stairs without difficulty?" urdu="کیا آپ بغیر کسی مشکل کے سیڑھیاں چڑھ سکتے ہیں؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="14" name="q14" eng="Do you have any physical deformity, disability, or medical condition?" urdu="کیا آپ کو کوئی جسمانی معذوری یا طبی مسئلہ ہے جو کام پر اثر انداز ہو سکتا ہو؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            {answers.q14 === 'Yes' && (
              <div style={{marginTop: '-10px', marginBottom: '20px'}}>
                <label style={styles.label}><span>If yes, please specify:</span> <span style={styles.urduLabel}>اگر ہاں وضاحت کریں</span></label>
                <input style={styles.input} name="q14_details" value={answers.q14_details} onChange={handleTextChange} />
              </div>
            )}
            <Question qNo="15" name="q15" eng="Do you own a laptop or desktop computer?" urdu="کیا آپ کے پاس ذاتی لیپ ٹاپ یا کمپیوٹر موجود ہے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            <Question qNo="16" name="q16" eng="Do you have any issue working at height (fear of height)?" urdu="کیا آپ کو اونچائی پر کام کرنے میں کوئی مسئلہ یا ڈر ہے؟" answers={answers} handleAnswerChange={handleAnswerChange} />

            {/* ✅ NEW: Shoe Size & Waist Size */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '10px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  <span>Shoe Size | جوتے کا سائز</span>
                </label>
                <input
                  style={{ ...styles.input, marginTop: '5px' }}
                  placeholder="e.g. 42 / UK 8"
                  name="shoe_size"
                  value={answers.shoe_size}
                  onChange={handleTextChange}
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  <span>Waist Size | کمر کا سائز</span>
                </label>
                <input
                  style={{ ...styles.input, marginTop: '5px' }}
                  placeholder='e.g. 32"'
                  name="waist_size"
                  value={answers.waist_size}
                  onChange={handleTextChange}
                />
              </div>
            </div>
          </div>

          {/* --- SECTION 4: EMERGENCY CONTACTS --- */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <span>Emergency Contact Information</span>
              <span style={{fontFamily: "'Noto Nastaliq Urdu', serif"}}>ہنگامی رابطہ معلومات</span>
            </div>
            <Question qNo="17" name="q17" eng="In case you are not reachable, do you agree to provide two emergency contact numbers?" urdu="اگر آپ سے رابطہ ممکن نہ ہو تو کیا آپ دو ہنگامی رابطہ نمبرز فراہم کریں گے؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            
            <div style={styles.contactsGrid}>
              <div style={styles.contactBox}>
                <div style={styles.contactTitle}>Emergency Contact 1 | ہنگامی رابطہ 1</div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Name | نام</label>
                  <input style={styles.input} name="contact1_name" value={answers.contact1_name} onChange={handleTextChange} />
                </div>
                <div style={{...styles.inputGroup, marginTop: '10px'}}>
                  <label style={styles.label}>Relation | رشتہ</label>
                  <input style={styles.input} name="contact1_relation" value={answers.contact1_relation} onChange={handleTextChange} />
                </div>
                <div style={{...styles.inputGroup, marginTop: '10px'}}>
                  <label style={styles.label}>Contact No. | نمبر</label>
                  <input style={styles.input} name="contact1_phone" value={answers.contact1_phone} onChange={handleTextChange} />
                </div>
              </div>

              <div style={styles.contactBox}>
                <div style={styles.contactTitle}>Emergency Contact 2 | ہنگامی رابطہ 2</div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Name | نام</label>
                  <input style={styles.input} name="contact2_name" value={answers.contact2_name} onChange={handleTextChange} />
                </div>
                <div style={{...styles.inputGroup, marginTop: '10px'}}>
                  <label style={styles.label}>Relation | رشتہ</label>
                  <input style={styles.input} name="contact2_relation" value={answers.contact2_relation} onChange={handleTextChange} />
                </div>
                <div style={{...styles.inputGroup, marginTop: '10px'}}>
                  <label style={styles.label}>Contact No. | نمبر</label>
                  <input style={styles.input} name="contact2_phone" value={answers.contact2_phone} onChange={handleTextChange} />
                </div>
              </div>
            </div>
          </div>

          {/* --- SECTION 5: PERSONAL INFORMATION --- */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <span>Personal Information</span>
              <span style={{fontFamily: "'Noto Nastaliq Urdu', serif"}}>ذاتی معلومات</span>
            </div>

            <div style={{ marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
              <label style={styles.label}><span>18) How do you like to spend your free time?</span> <span style={styles.urduLabel}>آپ اپنا فارغ وقت کس طرح گزارنا پسند کرتے ہیں؟</span></label>
              <textarea style={{...styles.input, height: '60px', marginTop: '5px'}} name="q18" value={answers.q18} onChange={handleTextChange} />
            </div>

            <Question qNo="19" name="q19" eng="Do you play any sport or engage in physical activity?" urdu="کیا آپ کوئی کھیل کھیلتے ہیں یا جسمانی سرگرمی میں حصہ لیتے ہیں؟" answers={answers} handleAnswerChange={handleAnswerChange} />
            {answers.q19 === 'Yes' && (
              <div style={{marginTop: '-10px', marginBottom: '20px'}}>
                <label style={styles.label}><span>If yes, specify:</span> <span style={styles.urduLabel}>اگر ہاں کون سا کھیل</span></label>
                <input style={styles.input} name="q19_details" value={answers.q19_details} onChange={handleTextChange} />
              </div>
            )}

            <Question qNo="20" name="q20" eng="Are you married?" urdu="کیا آپ شادی شدہ ہیں؟" answers={answers} handleAnswerChange={handleAnswerChange} />

            <div style={{ marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
              <label style={styles.label}><span>21) What is your blood group?</span> <span style={styles.urduLabel}>آپ کا بلڈ گروپ کیا ہے؟</span></label>
              <input style={{...styles.input, maxWidth: '200px', marginTop: '5px'}} placeholder="e.g. A+" name="q21" value={answers.q21} onChange={handleTextChange} />
            </div>
          </div>

          {/* --- DECLARATION --- */}
          <div style={styles.declaration}>
            <div style={{fontWeight: 'bold', fontSize: '16px', color: '#065f46', marginBottom: '10px'}}>Declaration | اقرار نامہ</div>
            <p style={styles.decText}>I confirm that the above information is true and correct to the best of my knowledge. I understand that any false information may lead to disqualification or termination as per company policy.</p>
            <p style={{...styles.decText, textAlign: 'right', fontFamily: "'Noto Nastaliq Urdu', serif"}}>میں تصدیق کرتا / کرتی ہوں کہ اوپر دی گئی تمام معلومات میرے علم کے مطابق درست ہیں، اور غلط معلومات کی صورت میں کمپنی پالیسی کے مطابق کارروائی ہو سکتی ہے۔</p>

            <div style={styles.signaturesRow}>
              <div style={styles.inputGroup}>
                <label style={styles.label}><span>Candidate Signature:</span> <span style={styles.urduLabel}>دستخط</span></label>
                <input style={styles.input} disabled placeholder="Digital Signature" />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}><span>Date:</span> <span style={styles.urduLabel}>تاریخ</span></label>
                <input style={styles.input} type="date" value={candidateInfo.date} disabled />
              </div>
            </div>
          </div>

          <button 
            onClick={handleSubmit}
            disabled={isSubmitting}
            style={{
              backgroundColor: isSubmitting ? '#9ca3af' : '#1e3a8a',
              color: 'white',
              padding: '12px 30px',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              marginTop: '20px'
            }}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Form | جمع کروائیں'}
          </button>

        </div>
      </div>
    </div>
  );
};

export default Part2Form;